import { Action, createReducer, on } from '@ngrx/store';
import { OnboardingState } from './onboarding.state';

import * as appActions from '@store/app/app.actions';
import * as customerActions from '@store/customer/customer.actions';
import * as onboardingActions from '@store/onboarding/onboarding.actions';
import * as paymentsActions from '@app/domain/store/payments/payments.actions';

export const initialOnboarding: OnboardingState = {
  information: null,
  auth10tix: null,
  application: null,
  isLoading: false,
  error: false,
  customerValidation: false,
  stepInfo: null,
};

const _onboardingReducer = createReducer(
  initialOnboarding,
  on(onboardingActions.requestOnboardingSession, (state, { step }) => {
    return {
      ...state,
      step,
      isLoading: true,
      error: false,
    };
  }),
  on(onboardingActions.successRequestOnboardingSession, (state, { information }) => {
    return {
      ...state,
      auth10tix: information?.data,
      information,
      isLoading: false,
      error: false,
    };
  }),
  on(onboardingActions.failureRequestOnboardingSession, (state) => {
    return {
      ...state,
      error: true,
      isLoading: false,
    };
  }),
  on(onboardingActions.getPreCustomer, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(onboardingActions.successGetPreCustomer, (state, { stepInfo }) => {
    return {
      ...state,
      stepInfo,
      isLoading: false,
      error: false,
    };
  }),
  on(onboardingActions.failureGetPreCustomer, (state) => {
    return {
      ...state,
      error: true,
      isLoading: false,
    };
  }),
  on(appActions.closeSession, (state) => {
    return {
      ...state,
      information: null,
      isLoading: false,
      error: false,
    };
  }),
  on(appActions.successKillPurchase, (state) => {
    return {
      ...state,
      information: null,
      isLoading: false,
      error: false,
    };
  }),
  on(onboardingActions.saveOnboardingStep, (state, { stepInfo }) => {
    return {
      ...state,
      isLoading: true,
      error: false,
      stepInfo: stepInfo
    };
  }),
  on(onboardingActions.successSaveOnboardingStep, (state) => {
    return {
      ...state,
      error: false,
    };
  }),
  on(onboardingActions.failureSaveOnboardingStep, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(onboardingActions.successUpgradeCustomer, (state) => {
    return {
      ...state,
      customerValidation: true,
      isLoading: false,
      error: false,
    };
  }),
  on(onboardingActions.failureUpgradeCustomer, (state) => {
    return {
      ...state,
      customerValidation: false,
      isLoading: false,
      error: false,
    };
  }),
  on(onboardingActions.saveAuth10tixStatus, (state) => {
    return {
      ...state,
      error: false,
    };
  }),
  on(onboardingActions.failureSaveOnboardingStep, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(onboardingActions.requestAuth10tixStatus, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(onboardingActions.successRequestAuth10tixStatus, (state, { auth10tix }) => {
    return {
      ...state,
      auth10tix,
      isLoading: false,
      error: false,
    };
  }),
  on(onboardingActions.failureRequestAuth10tixStatus, (state) => {
    return {
      ...state,
      error: true,
      isLoading: false,
    };
  }),
  on(onboardingActions.setKYCApplication, (state, { application }) => {
    return {
      ...state,
      application,
    };
  }),
  // DEMO
  on(onboardingActions.setUnderReviewAuth10tixStatus, (state, { status }) => {
    return {
      ...state,
      auth10tix: { ...state.auth10tix, status },
    };
  }),
  on(onboardingActions.setApprovedAuth10tixStatus, (state, { status }) => {
    return {
      ...state,
      auth10tix: { ...state.auth10tix, status },
    };
  }),
  on(customerActions.updateLoading, (state, { isLoading }) => {
    return {
      ...state,
      customerValidation: isLoading,
    };
  }),
  on(paymentsActions.redirecToPersonalInfo, (state) => {
    return {
      ...state,
      customerValidation: false,
    };
  })
);

export function onboardingReducers(state: OnboardingState | undefined, action: Action) {
  return _onboardingReducer(state, action);
}
